import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselFormComponent } from './vessel-form/vessel-form.component';
import { VesselViewComponent } from './vessel-view/vessel-view.component';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { VesselRoutingModule } from './vessel-routing.module';




@NgModule({
  declarations: [
    VesselFormComponent,
    VesselViewComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    MatDialogModule,
    VesselRoutingModule
  ]
})
export class VesselModule {
    title: 'Vessel Master';
 }
